<div class="card-body facebook-fundraiser-block" *ngIf="!isCurrentUserLinkedToFacebookFundraiser()">
    <div *ngIf="eventService?.isFacebookLinkingSupportedForSelectedEvent()">
        <h4 class="text-black mb-0 pb-0">
            <strong>Notifications</strong>
        </h4>
        <hr />
        <div>
            <div class="facebook-f-logo-block">
                <a><img class="facebook-f-logo" src="assets/img/FB-f-Logo__blue_72.png"/></a>
            </div>
            <div>
                <strong class="text-black">You can now link your fundraiser to Facebook</strong>
                <span class="text-muted d-block">Invite friends, share updates, track your progress, and collect donations with Facebook</span>
                <facebook-fundraiser-link></facebook-fundraiser-link>
            </div>
            <hr />
        </div>

    </div>
</div>